// extracted by mini-css-extract-plugin
export default {"expandIcon":"ExpandIcon_expandIcon__Rt19v","icon":"ExpandIcon_icon__Jq7ry","expanded":"ExpandIcon_expanded__jktKk"};